import './_style.scss';
import React, { Component } from 'react';
import c3 from "c3";
import PropTypes from "prop-types";
import _ from 'lodash';
import getPaletteColors from "../../../helpers/colorPaletteHelper";

class DonutChart extends Component {

    static propTypes = {
        data: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.number
        })),
        width: PropTypes.number
    };

    componentDidMount() {
        this.generateChart();
    }

    generateChart = () => {
        const {data, width} = this.props;
        const columns = _.orderBy(data, 'value', 'desc').map(d => [d.name, d.value]);

        c3.generate({
            bindto: '#donut-chart',
            color: {pattern: getPaletteColors(columns.length)},
            data: {
                columns: columns,
                type: 'donut'
            },
            donut: {
                label: {show: false},
                width: 50
            },
            legend: {hide: true},
            size: {width: width},
            tooltip: {show: false},
        });
    };

    render() {
        return <div id="donut-chart" className="donut-chart"/>;
    }
}

export default DonutChart;
